/**
 * PilotProgressBar component.
 */
import EpgEvent from '@shared/classes/epgEvent';
import ProgressBarLive from '@components/sections/progressBar/progressBarLive';
import ProgressBarVod from '@components/sections/progressBar/progressBarVod';
import { PilotType } from '@shared/types/props/pilot';
import { ProgressBarProps as Props } from '@shared/types/props/progressBar';

/**
 * Renders the pilot progress bar component.
 * Displays the progress bar for the channel or the vod.
 *
 * @param {Props} props - The props for the pilot progress bar component.
 * @returns {JSX.Element} The pilot progress bar component.
 */
export default function PilotProgressBar({ event, type }: Props) {
  return type === PilotType.LIVE ? (
    <ProgressBarLive event={event as EpgEvent} />
  ) : type === PilotType.VOD ? (
    <ProgressBarVod />
  ) : null;
}
